<template>
    <div style="height:100%;">
        <iframe height="100%" width="100%" id="iframe" v-bind:src="appUrl" style="border: 0;"></iframe>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                appUrl: ''
            }
        },
        mounted() {
            this.appUrl = this.$route.query.link
            const frame = document.getElementById('iframe'); 
            frame.contentWindow.postMessage ('123', '*');
            console.log(frame);
        },
        methods: {
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
    }
</style>
